
const homepageData = [
    {
        id : 1,
        image : require("../assets/green/home/quran.png"),
        title : {
            en : "Quran",
            ar : "القرآن الكريم",
            fr : "Lire Coran"
        }
    },
    {
        id : 2,
        image : require("../assets/green/home/prayFor.png"),
        title : {
            en : "Dua",
            ar : "الدعاء",
            fr : "Douâa"
        }
    },
    {
        id : 3,
        image : require("../assets/green/home/prayerTime.png"),
        title : {
            en : "Prayer Time",
            ar : "أوقات الصلاة",
            fr : "Horaires de prières"
        }
    },
    {
        id : 4,
        image : require("../assets/green/home/godNames.png"),
        title : {
            en : "99 Names of Allah",
            ar : "اسماء الله الحسنى",
            fr : "99 noms d'Allah"
        }
    },
    {
        id : 5,
        image : require("../assets/green/home/backgrounds.png"),
        title : {
            en : "Wallpapers",
            ar : "خلفيات",
            fr : "Fonds d’écran"
        }
    },
    {
        id : 6,
        image : require("../assets/green/home/conversations.png"),
        title : {
            en : "Hadidth",
            ar : "أحاديث",
            fr : "Hadiths"
        }
    }
]

const quranData = {
    en :  ["AL-FATIHA", "AL-BAQARAH", "AL-IMRAN", "AN-NISA", "AL-MAIDAH", "AL-ANAM", "AL-ARAF", "AL-ANFAL", "AT-TAWBAH", "YUNUS", "HUD", "YUSUF", "AR-RAAD", "IBRAHIM", "AL-HIJRAL", "AN-NAHL", "AL-ISRA", "AL-KAHF", "MARYAM", "TA-HA", "AL-ANBIYA", "AL-HAJJ", "AL-MUMINUNE", "AN-NUR", "AL FURQANE", "AS-SHUARAA", "AN-NAML", "AL-QASAS", "AL-ANKABUT", "AR-RUM", "LUQMAN", "AS-SAJDA", "AL-AHZAB", "SABA", "FATIR", "YAS-IN", "AS-SAFFAT", "SAD", "AZ-ZUMAR", "GAFIR", "FUSSILAT", "ACHOURA", "AZZUKHRUF", "AD-DUKHAN", "AL-JATHYA", "AL-AHQAF", "MUHAMMAD", "AL-FATH", "AL-HUJURAT", "QAF", "AD-DARIYAT", "AT-TUR", "AN-NAJM", "AL-QAMAR", "AR-RAHMAN", "AL-WAQI'A", "AL-HADID", "AL-MUJADALAH", "AL-HASR", "AL-MUMTAHANAH", "AS-SAFF", "AL-JUMUA", "AL-MUNAFIQUN", "AT-TAGABUN", "AT-TALAQ", "AT-TAHRIM", "AL-MULK", "AL-QALAM", "AL-HAQQAH", "AL- MAARIJ", "NUH", "AL-JINN", "AL-MUZZAMIL", "AL-MUDDATTIR", "AL-QIYAMAH", "AL-INSAN", "AL-MURSALATE", "AN-NABA", "AN-NAZIATE", "ABASAI", "AT-TAKWIR", "AL-INFITAR", "AL-MUTAFFIFUNE", "AL-INSIQAQ", "AL-BURUJ", "AT-TARIQ", "AL-ALA", "AL-GASIYAH", "AL-FAJR", "AL-BALAD", "ACH-CHAMS", "AL-LAYL", "AD-DUHA", "AS-SARH", "AT-TIN", "AL-ALAQ", "AL-QADR", "AL-BAYYINAH", "AZ-ZALZALAH", "AL-ADIYATE", "AL-QARIAH", "AT-TAKATUR", "AL-ASR", "AL-HUMAZAH", "AL-FIL", "CORAÃSH", "AL-MAUN", "AL-KAWTAR", "AL-KAFIRUNE", "AN-NASR", "AL-MASAD", "AL-IKHLAS", "AL-FALAQ", "AN-NAS"],
    ar :  ["الفاتحة", "البقرة", "آل عمران", "النساء", "المائدة", "الأنعام", "الأعراف", "الأنفال", "التوبة", "يونس", "هود", "يوسف", "الرعد", "إبراهيم", "الحجر", "النحل", "الإسراء", "الكهف", "مريم", "طه", "الأنبياء", "الحج", "المؤمنون", "النور", "الفرقان", "الشعراء", "النمل", "القصص", "العنكبوت", "الروم", "لقمان", "السجدة", "الأحزاب", "سبأ", "فاطر", "يس", "الصافات", "ص", "الزمر", "غافر", "فصلت", "الشورى", "الزخرف", "الدخان", "الجاثية", "الأحقاف", "محمد", "الفتح", "الحجرات", "ق", "الذاريات", "الطور", "النجم", "القمر", "الرحمن", "الواقعة", "الحديد", "المجادلة", "الحشر", "الممتحنة", "الصف", "الجمعة", "المنافقون", "التغابن", "الطلاق", "التحريم", "الملك", "القلم", "الحاقة", "المعارج", "نوح", "الجن", "المزّمِّل", "المدّثر", "القيامة", "الإنسان", "المرسلات", "النبأ", "النازعات", "عبس", "التكوير", "الانفطار", "المطففين", "الانشقاق", "البروج", "الطارق", "الأعلى", "الغاشية", "الفجر", "البلد", "الشمس", "الليل", "الضحى", "الشرح", "التين", "العلق", "القدر", "البينة", "الزلزلة", "العاديات", "القارعة", "التكاثر", "العصر", "الهُمَزَة", "الفيل", "قريش", "الماعون", "الكوثر", "الكافرون", "النصر", "المسد", "الإخلاص", "الفلق", "الناس"],
    fr : [' AL-FÂTIHAH ',' AL-BAQARAH ',' AL ‘IMRÂN ',' AN-NISÂ’ ',' AL-MÂÏDAH ',' AL-AN’ÂM ',' AL-A’RÂF ',' AL-ANFÂL ',' AT-TAWBAH ',' YOUNOUS ',' HOUD ',' YOUSOUF ',' AR-RA’D ',' IBRÂHÎM ',' AL-HIJR ',' AN-NAHL ',' AL-ISRÂ’ ',' AL-KAHF ',' MARIAM ',' TÂ-HÂ ',' AL-ANBIYÂ’ ',' AL-HAJJ ',' AL-MOU’MINOUN ',' AN-NOUR ',' AL-FOURQÂN ',' ACH-CHOU’ARÂ’ ',' AN-NAML ',' AL-QASAS ',' AL-‘ANKABOUT ',' AR-ROUM ',' LOUQMAN ',' AS-SAJDAH ',' AL-AHZÂB ',' SABA ',' FÂTIR ',' YÂ-SÎN ',' AS-SÂFFÂT ',' SÂD ',' AZ-ZOUMAR ',' GHÂFIR ',' FOUSSILAT ',' ACH-CHOURÂ ',' AZ-ZOUKHROUF ',' AD-DOUKHÂN ',' AL-JÂTHIYAH ',' AL-AHQÂF ',' MOUHAMMAD ',' AL-FAT’H ',' AL-HOUJOURÂT ',' QÂF ',' ADH-DHÂRIYÂT ',' AT-TOUR ',' AN-NAJM ',' AL-QAMAR ',' AR-RAHMÂN ',' AL-WÂQI’AH ',' AL-HADÎD ',' AL-MOUJÂDALAH ',' AL-HACHR ',' AL-MOUMTAHANAH ',' AS-SAFF ',' AL-JOUMOU’AH ',' AL-MOUNÂFIQOUN ',' AT-TAGHÂBOUN ',' AT-TALÂQ ',' AT-TAHRÎM ',' AL-MOULK ',' AL-QALAM ',' AL-HÂQQAH ',' AL-MA’ÂRIJ ',' NOUH ',' AL-JINN ',' AL-MOUZZAMMIL ',' AL-MOUDDATHTHIR ',' AL-QIYÂMAH ',' AL-INSÂN ',' AL-MOURSALÂT ',' AN-NABA’ ',' AN-NÂZI’ÂT ',' ‘ABASA ',' AT-TAKWÎR ',' AL-INFITÂR ',' AL-MOUTAFFIFOUN ',' AL-INCHIQÂQ ',' AL-BOUROUJ ',' AT-TÂRIQ ',' AL-A’LÂ ',' AL-GHÂCHIYAH ',' AL-FAJR ',' AL-BALAD ',' ACH-CHAMS ',' AL-LAYL ',' AD-DOUHÂ ',' ACH-CHARH ',' AT-TÎN ',' AL-‘ALAQ ',' AL-QADR ',' AL-BAYYINAH ',' AZ-ZALZALAH ',' AL-‘ÂDIYÂT ',' AL-QÂRI’AH ',' AT-TAKÂTHOUR ',' AL-‘ASR ',' AL-HOUMAZAH ',' AL-FÎL ',' QOURAYCH ',' AL-MÂ’OUN ',' AL-KAWTHAR ',' AL-KÂFIROUN ',' AN-NASR ',' AL-MASAD ',' AL-IKHLÂS ',' AL-FALAQ ',' AN-NÂS ',]
}

const quranDetails =
     [ [
        {
            en : "",
            ar : "بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ.",
            fr : "Au nom d'Allah, le Tout Miséricordieux, le Très Miséricordieux ."
        },
        {
            en : "",
            ar : "ٱلْحَمْدُ لِلَّهِ رَبِّ ٱلْعَٰلَمِينَ.",
            fr : "Louange à Allah, Seigneur de l'univers."
        },
        {
            en : "",
            ar : "ٱلرَّحْمَٰنِ ٱلرَّحِيمِ.",
            fr : "Le Tout Miséricordieux, le Très Miséricordieux,"
        },
        {
            en : "",
            ar : "مَٰلِكِ يَوْمِ ٱلدِّينِ.",
            fr : "Maître du Jour de la rétribution."
        },
        {
            en : "",
            ar : "إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ.",
            fr : "C'est Toi [Seul] que nous adorons, et c'est Toi [Seul] dont nous implorons secours.",
        },
        {
            en : "",
            ar : "ٱهْدِنَا ٱلصِّرَٰطَ ٱلْمُسْتَقِيمَ.",
            fr : "Guide-nous dans le droit chemin,"
        },
        {
            en : "",
            ar : "صِرَٰطَ ٱلَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ ٱلْمَغْضُوبِ عَلَيْهِمْ وَلَا ٱلضَّآلِّينَ.",
            fr : "le chemin de ceux que Tu as comblés de faveurs, non pas de ceux qui ont encouru Ta colère, ni des égarés ."
        }
    ],
      [
        {
            en : "",
            ar : "ِالٓمٓ",
            fr : "Alif, Lam, Mim ."
        },
        {
            en : "",
            ar : "ذَٰلِكَ ٱلْكِتَٰبُ لَا رَيْبَ ۛ فِيهِ ۛ هُدًۭى لِّلْمُتَّقِينَ.",
            fr : "C'est le Livre au sujet duquel il n'y a aucun doute, c'est un guide pour les pieux"
        },
        {
            en : "",
            ar : "ٱلَّذِينَ يُؤْمِنُونَ بِٱلْغَيْبِ وَيُقِيمُونَ ٱلصَّلَوٰةَ وَمِمَّا رَزَقْنَٰهُمْ يُنفِقُونَ.",
            fr : "qui croient à l'invisible et accomplissent la Salat et dépensent [dans l'obéissance à Allah], de ce que Nous leur avons attribué"
        },
        {
            en : "",
            ar : "وَٱلَّذِينَ يُؤْمِنُونَ بِمَآ أُنزِلَ إِلَيْكَ وَمَآ أُنزِلَ مِن قَبْلِكَ وَبِٱلْءَاخِرَةِ هُمْ يُوقِنُونَ.",
            fr : "Ceux qui croient à ce qui t'a été descendu (révélé) et à ce qui a été descendu avant toi et qui croient fermement à la vie future."
        },
       {
            en : "",
            ar : "أُو۟لَٰٓئِكَ عَلَىٰ هُدًۭى مِّن رَّبِّهِمْ ۖ وَأُو۟لَٰٓئِكَ هُمُ ٱلْمُفْلِحُونَ.",
            fr : "Ceux-là sont sur le bon chemin de leur Seigneur, et ce sont eux qui réussissent (dans cette vie et dans la vie future).",
        },
        {
            en : "",
            ar : "إِنَّ ٱلَّذِينَ كَفَرُوا۟ سَوَآءٌ عَلَيْهِمْ ءَأَنذَرْتَهُمْ أَمْ لَمْ تُنذِرْهُمْ لَا يُؤْمِنُونَ.",
            fr : "[Mais] certes les infidèles ne croient pas, cela leur est égal, que tu les avertisses ou non : ils ne croiront jamais."
        },
        {
            en : "",
            ar : "خَتَمَ ٱللَّهُ عَلَىٰ قُلُوبِهِمْ وَعَلَىٰ سَمْعِهِمْ ۖ وَعَلَىٰٓ أَبْصَٰرِهِمْ غِشَٰوَةٌۭ ۖ وَلَهُمْ عَذَابٌ عَظِيمٌۭ.",
            fr : "Allah a scellé leurs coeurs et leurs oreilles; et un voile épais leur couvre la vue; et pour eux il y aura un grand châtiment."
        }
    ]
     ]

const duaData = {
    en : ["Dua 1", "Dua 2", "Dua 3", "Dua 4", "Dua 5", "Dua 6", "Dua 7", "Dua 8", "Dua 9", "Dua 10", "Dua 11", "Dua 12", "Dua 13", "Dua 14", "Dua 15", "Dua 16", "Dua 17", "Dua 18", "Dua 19", "Dua 20", "Dua 21", "Dua 22", "Dua 23", "Dua 24", "Dua 25", "Dua 26", "Dua 27", "Dua 28", "Dua 29", "Dua 30", "Dua 31", "Dua 32", "Dua 33", "Dua 34", "Dua 35", "Dua 36", "Dua 37", "Dua 38", "Dua 39", "Dua 40"],
    ar : ['دعاء 1','دعاء 2','دعاء 3','دعاء 4','دعاء 5','دعاء 6','دعاء 7','دعاء 8','دعاء 9','دعاء 10','دعاء 11','دعاء 12','دعاء 13','دعاء 14','دعاء 15','دعاء 16','دعاء 17','دعاء 18','دعاء 19','دعاء 20','دعاء 21','دعاء 22','دعاء 23','دعاء 24','دعاء 25','دعاء 26','دعاء 27','دعاء 28','دعاء 29','دعاء 30','دعاء 31','دعاء 32','دعاء 33','دعاء 34','دعاء 35','دعاء 36','دعاء 37','دعاء 38','دعاء 39','دعاء 40',],
    fr : ["Doua 1", "Doua 2", "Doua 3", "Doua 4", "Doua 5", "Doua 6", "Doua 7", "Doua 8", "Doua 9", "Doua 10", "Doua 11", "Doua 12", "Doua 13", "Doua 14", "Doua 15", "Doua 16", "Doua 17", "Doua 18", "Doua 19", "Doua 20", "Doua 21", "Doua 22", "Doua 23", "Doua 24", "Doua 25", "Doua 26", "Doua 27", "Doua 28", "Doua 29", "Doua 30", "Doua 31", "Doua 32", "Doua 33", "Doua 34", "Doua 35", "Doua 36", "Doua 37", "Doua 38", "Doua 39", "Doua 40"]

}


const duaAudios = {
  en: [ 'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/1.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/2.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/3.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/4.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/5.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/6.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/7.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/8.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/9.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/10.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/11.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/12.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/13.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/14.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/15.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/16.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/17.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/18.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/19.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/20.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/21.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/22.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/23.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/24.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/25.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/26.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/27.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/28.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/29.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/30.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/31.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/32.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/33.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/34.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/35.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/36.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/37.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/38.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/39.mp3',
    'https://islamic.s3.ap-south-1.amazonaws.com/duas/en/40.mp3',
     ],

  fr: [ 'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/1.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/2.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/3.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/4.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/5.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/6.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/7.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/8.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/9.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/10.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/11.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/12.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/13.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/14.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/15.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/16.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/17.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/18.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/19.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/20.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/21.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/22.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/23.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/24.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/25.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/26.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/27.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/28.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/29.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/30.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/31.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/32.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/33.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/34.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/35.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/36.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/37.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/38.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/39.mp3',
        'https://islamic.s3.ap-south-1.amazonaws.com/duas/fr/40.mp3',
         ]

}
const duaDetails = {
    en: ["Our Lord! Accept (this service) from us: For Thou art the All-Hearing, the All-knowing [2:127]",
    "Our Lord! Make of us Muslims, bowing to Thy (Will), and of our progeny a people Muslim, bowing to Thy (will); and show us our place for the celebration of (due) rites; and turn unto us (in Mercy); for Thou art the Oft-Returning, Most Merciful [2:128]",
    "Our Lord! Grant us good in this world and good in the hereafter, and save us from the chastisement of the fire [2:201]",
    "Our Lord! Bestow on us endurance, make our foothold sure, and give us help against the disbelieving folk [2:250]",
    "Our Lord! Condemn us not if we forget or fall into error [2:286]",
    "Our Lord! Lay not on us a burden Like that which Thou didst lay on those before us [2:286]",
    "Our Lord! Lay not on us a burden greater than we have strength to bear. Blot out our sins, and grant us forgiveness. Have mercy on us. Thou art our Protector; Help us against those who stand against faith [2:286]",
    "Our Lord! (they say), Let not our hearts deviate now after Thou hast guided us, but grant us mercy from Thine own Presence; for Thou art the Grantor of bounties without measure [3:8]",
    "Our Lord! Thou art He that will gather mankind Together against a day about which there is no doubt; for Allah never fails in His promise. [3:9]",
    "Our Lord! We have indeed believed: forgive us, then, our sins, and save us from the agony of the Fire [3:16]",
    "Our Lord! We believe in what Thou hast revealed, and we follow the Messenger. Then write us down among those who bear witness [3:53]",
    "Our Lord! Forgive us our sins and anything We may have done that transgressed our duty: Establish our feet firmly, and help us against those that resist Faith [3:147]",
    "Our Lord! Not for naught Hast Thou created (all) this! Glory to Thee! Give us salvation from the penalty of the Fire [3:191]",
    "Our Lord! Any whom Thou dost admit to the Fire, Truly Thou coverest with shame, and never will wrong-doers Find any helpers! [3:192]",
    "Our Lord! We have heard the call of one calling (Us) to Faith, 'Believe ye in the Lord,' and we have believed [3:193]",
    "Our Lord! Forgive us our sins, blot out from us our iniquities, and take to Thyself our souls in the company of the righteous [3:193]",
    "Our Lord! Grant us what Thou didst promise unto us through Thine apostles, and save us from shame on the Day of Judgment: For Thou never breakest Thy promise [3:194]",
    "Our Lord! We believe; write us down among the witnesses [5:83]",
    "O Allah our Lord! Send us from heaven a table set (with viands), that there may be for us - for the first and the last of us - a solemn festival and a sign from thee; and provide for our sustenance, for thou art the best Sustainer (of our needs) [5:114]",
    "Our Lord! We have wronged our own souls: If thou forgive us not and bestow not upon us Thy Mercy, we shall certainly be lost [7:23]",
    "Our Lord! Send us not to the company of the wrong-doers [7:47]",
    "Our Lord! Decide Thou between us and our people in truth, for Thou art the best to decide [7:89]",
    "Our Lord! Pour out on us patience and constancy, and take our souls unto thee as Muslims (who bow to thy will) [7:126]",
    "Our Lord! Make us not a trial for those who practise oppression; And deliver us by Thy Mercy from those who reject (Thee) [10:85-86]",
    "O our Lord! Truly Thou dost know what we conceal and what we reveal: for nothing whatever is hidden from Allah, whether on earth or in heaven [14:38]",
    "O our Lord! And accept my Prayer [14:40]",
    "O our Lord! Cover (us) with Thy Forgiveness - me, my parents, and (all) Believers, on the Day that the Reckoning will be established! [14:41]",
    "Our Lord! Bestow on us Mercy from Thyself, and dispose of our affair for us in the right way! [18:10]",
    "Our Lord! We fear lest he hasten with insolence against us, or lest he transgress all bounds [20: 45]",
    "Our Lord! We believe; then do Thou forgive us, and have mercy upon us: For Thou art the Best of those who show mercy [23: 109]",
    "Our Lord! Avert from us the Wrath of Hell, for its Wrath is indeed an affliction grievous,- Evil indeed is it as an abode, and as a place to rest in [25: 65-66]",
    "O my Lord! Grant unto us wives and offspring who will be the comfort of our eyes, and give us (the grace) to lead the righteous [25:74]",
    "Our Lord is indeed Oft-Forgiving Ready to appreciate (service) [35: 34]",
    "Our Lord! Thy Reach is over all things, in Mercy and Knowledge. Forgive, then, those who turn in Repentance, and follow Thy Path; and preserve them from the Penalty of the Blazing Fire! [40:7]",
    "And grant, our Lord! that they enter the Gardens of Eternity, which Thou hast promised to them, and to the righteous among their fathers, their wives, and their posterity! For Thou art (He), the Exalted in Might, Full of Wisdom. And preserve them from (all) ills; and any whom Thou dost preserve from ills that Day,- on them wilt Thou have bestowed Mercy indeed: and that will be truly (for them) the highest Achievement [40:8-9]",
    "Our Lord! Forgive us, and our brethren who came before us into the Faith, and leave not, in our hearts, rancour (or sense of injury) against those who have believed [59:10]",
    "Our Lord! Thou art indeed Full of Kindness, Most Merciful [59:10]",
    "Our Lord! In Thee do we trust, and to Thee do we turn in repentance: to Thee is (our) Final Goal [60:4]",
    "Our Lord! Make us not a (test and) trial for the Unbelievers, but forgive us, our Lord! for Thou art the Exalted in Might, the Wise [60:5]",
    "Our Lord! Perfect our Light for us, and grant us Forgiveness: for Thou hast power over all things [66:8]",
    ,],
    fr: [
        "Seigneur, accepte notre œuvre. Toi qui entends et sais tout!",
        "Seigneur, fais que nous soyons soumis à Ta volonté, fais que notre postérité soit un peuple résigné à Ta volonté, enseigne-nous les rites sacrés, et accepte notre repentir, car Tu aimes à agréer la pénitence et Tu es Miséricordieux",
        "Seigneur, donne-nous une belle part dans ce monde et une belle part dans l'Autre, et préserve-nous du châtiment du feu!",
        "Seigneur, arme-nous de patience, affermis nos pas et donne-nous la victoire sur ce peuple infidèle !",
        "Seigneur, ne nous punis pas pour des fautes commises par oubli ou par erreur",
        "Seigneur, ne nous impose pas le fardeau que Tu savais imposé à ceux qui ont vécu avant nous ",
        "Seigneur, ne nous charge pas de ce que nous ne pouvons supporter. Efface nos pêchés, pardonne les nous, aie pitié de nous ! Tu es notre Maître ! Donne-nous la victoire sur les infidèles !",
        "Seigneur ! ne fais pas dévier nos coeurs après que tu nous as guidés ! Accorde-nous Ta miséricorde, car Tu es le Dispensateur Suprême" ,
        " Seigneur ! Tu rassembleras le genre humain dans un jour au sujet duquel il n'y a point de doute ! Certes, Allah ne manque point à Ses promesses !",
        "Seigneur, nous avons cru ; pardonqe-nous nos péchés et préserve-nous du châtiment feu ",
        "Seigneur, nous croyons à ce que Tu as révêlé, et nous suivons le Prohète ! Inscris-nous au nombre de ceux qui témoignent !",
        " Seigneur, pardonne-nous nos péchés et nos excès. Affermis nos pas et accorde-nous la victoire sur les infidèles",
        "Seigneur, Tu n'as pas créé tout cela en vain (l'univers) ! Gloire à Toi ! Préserve-nous du châtiment du Feu ",
        "Seigneur, celui que Tu précipites en enfer tombe dans l'ignominie, les pervers ne pourront compter sur aucun secours",
        "Seigneur, nous avons entendu l'homme qui appelait ; il nous appelait à la Foi, il criait: «Croyez en Dieu», et nous avons cru",
        "Seigneur, pardonne-nous nos fautes, efface nos péchés, et fais que nous mourions avec les gens charitables",
        "Seigneur, donne-nous ce que Tu as promis par l'intermédiaire de Tes Messagers ! Fais que nous ne soyons pas humiliés au jour de la résurrection, Toi qui ne manques jamais à Tes promesses",
        "Seigneur, nous croyons ! Inscris-nous au nombre de ceux qui témoignent ! ",
        "Seigneur, fais-nous descendre une table du ciel ; qu'elle soit un festin pour le premier et le dernier d'entre nous, et un signe de Ta puissance ! Nourris-nous, car Tu es le meilleur Nourrisseur",
        "Seigneur, nous sommes coupables ! Si Tu ne nous pardonnes pas et si Tu n'as pas pitié de nous, nous sommes perdants",
        " Seigneur, ne nous place pas avec les injustes ",
        "Seigneur, tranche entre nous et notre peuple. Tu es le meilleur des arbitres ! ",
        "Seigneur, Déverse sur nous l'endurance et fais nous mourir entièrement soumis ",
        "Seigneur, ne fais pas de nous une cible pour les persécutions des injustes ! Par Ta miséricorde, protège-nous des infidèles ",
        "Seigneur, Tu sais ce que nous dissimulons et ce que nous montrons ! Pour Dieu, il y a rien de caché dans les Cieux et sur la Terre !",
        "O mon Seigneur ! Fais que j'accomplisse assidûment la Salat ainsi qu'une partie de ma descendance; exauce ma prière, ô notre Seigneur",
        "Seigneur, pardonne-moi, ainsi qu'à mes parents (père et mère) et aux croyants, au jour du Jugement ",
        "Seigneur, accorde-nous Ta miséricorde et assure-nous la droiture de notre conduite",
        "Seigneur, nous craignons qu'il n'use de violence envers nous, ou qu'il ne commette des impiétés ",
        "Seigneur, nous croyons en Toi, pardonne nous, fais-nous miséricorde, Tu es le plus miséricordieux",
        "Seigneur, éloigne-nous du supplice de l'enfer, qui est vraiment le plus atroce des supplices, ainsi qu'un mauvais lieu pour y séjourner et pour s'y arrêter",
        "Seigneur, fait que la vue de nos épouses et de nos enfants nous remplit de joie ! Et fais que nous marchions à la tête des pieux ",
        "Notre Seigneur est indulgent et reconnaissant ",
        "Seigneur, Tu embrasses tout de Ta miséricorde et de Ta science, pardonne à ceux qui se repentent et suivent Ton sentier ! Préserve-les du supplice de l'enfer",
        " Seigneur, introduis-les dans les jardins d'Éden que Tu leur as promis, ainsi que leurs parents, leurs épouses et leurs enfants vertueux ! Tu es le Puissant, le, Sage ! Préserve-les du mal ! Tu auras pitié de celui qui se gardera des mauvaises actions, et c'est un bonheur immense !",
        "Seigneur, pardonne-nous et pardonne à nos frères qui nous ont devancés dans la Foi, et ne mets point dans nos cœurs de rancune contre ceux qui croient! Seigneur, Tu es compatissant et miséricordieux!",
        "Seigneur, ne nous induis pas en tentation pour ceux qui ne croient pas ! pardonne-nous, Tu es puissant et sage",
        "Seigneur, nous mettons notre confiance en Toi, nous revenons à Toi. C'est à Toi que tout aboutit !",
        "Seigneur, ne nous induis pas en tentation pour ceux qui ne croient pas ! Pardonne-nous, Tu es puissant et sage !",
        "Seigneur, rends parfaite notre lumière, et pardonne-nous ! Tu es Tout-Puissânt"
        ],
    ar: ["رَبَّنَا تَقَبَّلْ مِنَّا إِنَّكَ أَنْتَ السَّمِيعُ العَلِيمُ",
    "رَبَّنَا وَاجْعَلْنَا مُسْلِمَيْنِ لَكَ وَمِن ذُرِّيَّتِنَا أُمَّةً مُّسْلِمَةً لَّكَ وَأَرِنَا مَنَاسِكَنَا وَتُبْ عَلَيْنَآ إِنَّكَ أَنتَ التَّوَّابُ الرَّحِيمُ",
    "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
    "رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْراً وَثَبِّتْ أَقْدَامَنَا وَانصُرْنَا عَلَى القَوْمِ الكَافِرِينَ",
    "رَبَّنَا لاَ تُؤَاخِذْنَا إِن نَّسِينَا أَوْ أَخْطَأْنَا",
    "رَبَّنَا وَلاَ تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِن قَبْلِنَا",
    "رَبَّنَا وَلاَ تُحَمِّلْنَا مَا لاَ طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنتَ مَوْلاَنَا فَانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
    "رَبَّنَا لاَ تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً إِنَّكَ أَنتَ الْوَهَّابُ",
    "رَبَّنَا إِنَّكَ جَامِعُ النَّاسِ لِيَوْمٍ لاَّ رَيْبَ فِيهِ إِنَّ اللّهَ لاَ يُخْلِفُ الْمِيعَادَ",
    "رَبَّنَا إِنَّنَا آمَنَّا فَاغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ النَّارِ",
    "رَبَّنَآ ءَامَنَّا بِمَآ أَنزَلْتَ وَٱتَّبَعْنَا ٱلرَّسُولَ فَٱكْتُبْنَا مَعَ ٱلشَّٰهِدِينَ",
    "ربَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَِ",
    "رَبَّنَا مَا خَلَقْتَ هَذا بَاطِلاً سُبْحَانَكَ فَقِنَا عَذَابَ النَّارِ",
    "رَبَّنَا إِنَّكَ مَن تُدْخِلِ النَّارَ فَقَدْ أَخْزَيْتَهُ وَمَا لِلظَّالِمِينَ مِنْ أَنصَارٍ",
    "رَّبَّنَا إِنَّنَا سَمِعْنَا مُنَادِيًا يُنَادِي لِلإِيمَانِ أَنْ آمِنُواْ بِرَبِّكُمْ فَآمَنَّا",
    "رَبَّنَا فَاغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّئَاتِنَا وَتَوَفَّنَا مَعَ الأبْرَارِ",
    "رَبَّنَا وَآتِنَا مَا وَعَدتَّنَا عَلَى رُسُلِكَ وَلاَ تُخْزِنَا يَوْمَ الْقِيَامَةِ إِنَّكَ لاَ تُخْلِفُ الْمِيعَاد",
    "رَبَّنَا آمَنَّا فَاكْتُبْنَا مَعَ الشَّاهِدِينَ",
    "رَبَّنَا أَنزِلْ عَلَيْنَا مَآئِدَةً مِّنَ السَّمَاء تَكُونُ لَنَا عِيداً لِّأَوَّلِنَا وَآخِرِنَا وَآيَةً مِّنكَ وَارْزُقْنَا وَأَنتَ خَيْرُ الرَّازِقِينَ",
    "رَبَّنَا ظَلَمْنَا أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ",
    "رَبَّنَا لاَ تَجْعَلْنَا مَعَ الْقَوْمِ الظَّالِمِينَ",
    "رَبَّنَا افْتَحْ بَيْنَنَا وَبَيْنَ قَوْمِنَا بِالْحَقِّ وَأَنتَ خَيْرُ الْفَاتِحِينَ",
    "رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَتَوَفَّنَا مُسْلِمِينَ",
    "رَبَّنَا لاَ تَجْعَلْنَا فِتْنَةً لِّلْقَوْمِ الظَّالِمِينَ ; وَنَجِّنَا بِرَحْمَتِكَ مِنَ الْقَوْمِ الْكَافِرِينَ",
    "رَبَّنَا إِنَّكَ تَعْلَمُ مَا نُخْفِي وَمَا نُعْلِنُ وَمَا يَخْفَى عَلَى اللّهِ مِن شَيْءٍ فَي الأَرْضِ وَلاَ فِي السَّمَاء",
    "رَبِّ اجْعَلْنِي مُقِيمَ الصَّلاَةِ وَمِن ذُرِّيَّتِي رَبَّنَا وَتَقَبَّلْ دُعَاء",
    "رَبَّنَا اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ",
    "رَبَّنَا آتِنَا مِن لَّدُنكَ رَحْمَةً وَهَيِّئْ لَنَا مِنْ أَمْرِنَا رَشَدًا",
    "رَبَّنَا إِنَّنَا نَخَافُ أَن يَفْرُطَ عَلَيْنَا أَوْ أَن يَطْغَى",
    "رَبَّنَا آمَنَّا فَاغْفِرْ لَنَا وَارْحَمْنَا وَأَنتَ خَيْرُ الرَّاحِمِينَ",
    "رَبَّنَا اصْرِفْ عَنَّا عَذَابَ جَهَنَّمَ إِنَّ عَذَابَهَا كَانَ غَرَامًا إِنَّهَا سَاءتْ مُسْتَقَرًّا وَمُقَامًا",
    "رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
    "رَبَّنَا لَغَفُورٌ شَكُورٌ",
    "رَبَّنَا وَسِعْتَ كُلَّ شَيْءٍ رَّحْمَةً وَعِلْماً فَاغْفِرْ لِلَّذِينَ تَابُوا وَاتَّبَعُوا سَبِيلَكَ وَقِهِمْ عَذَابَ الْجَحِيمِ",
    "رَبَّنَا وَأَدْخِلْهُمْ جَنَّاتِ عَدْنٍ الَّتِي وَعَدتَّهُم وَمَن صَلَحَ مِنْ آبَائِهِمْ وَأَزْوَاجِهِمْ وَذُرِّيَّاتِهِمْ إِنَّكَ أَنتَ الْعَزِيزُ الْحَكِيمُ وَقِهِمُ السَّيِّئَاتِ وَمَن تَقِ السَّيِّئَاتِ يَوْمَئِذٍ فَقَدْ رَحِمْتَهُ وَذَلِكَ هُوَ الْفَوْزُ الْعَظِيمُ",
    "رَبَّنَا اغْفِرْ لَنَا وَلِإِخْوَانِنَا الَّذِينَ سَبَقُونَا بِالْإِيمَانِ وَلَا تَجْعَلْ فِي قُلُوبِنَا غِلًّا لِّلَّذِينَ آمَنُوا",
    "رَبَّنَا إِنَّكَ رَؤُوفٌ رَّحِيمٌ ",
    "رَّبَّنَا عَلَيْكَ تَوَكَّلْنَا وَإِلَيْكَ أَنَبْنَا وَإِلَيْكَ الْمَصِيرُ",
    "رَبَّنَا لَا تَجْعَلْنَا فِتْنَةً لِّلَّذِينَ كَفَرُوا وَاغْفِرْ لَنَا رَبَّنَا إِنَّكَ أَنتَ الْعَزِيزُ الْحَكِيمُ",
    "رَبَّنَا أَتْمِمْ لَنَا نُورَنَا وَاغْفِرْ لَنَا إِنَّكَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ"]
}

const allahNames =  {
en : [  "AR-RAHMAAN",
        "AR-RAHEEM",
        "AL-MALIK",
        "AL-QUDDUS",
        "AS-SALAM",
        "AL-MU’MIN",
        "AL-MUHAYMIN",
        "AL-AZIZ",
        "AL-JABBAR",
        "AL-MUTAKABBIR",
        "AL-KHAALIQ",
        "AL-BAARI",
        "AL-MUSAWWIR",
        "AL-GHAFFAR",
        "AL-QAHHAR",
        "AL-WAHHAAB",
        "AR-RAZZAAQ",
        "AL-FATTAAH",
        "AL-‘ALEEM",
        "AL-QAABID",
        "AL-BAASIT",
        "AL-KHAAFIDH",
        "AR-RAAFI’",
        "AL-MU’IZZ",
        "AL-MUZIL",
        "AS-SAMEE’",
        "AL-BASEER",
        "AL-HAKAM",
        "AL-‘ADL",
        "AL-LATEEF",
        "AL-KHABEER",
        "AL-HALEEM",
        "AL-‘AZEEM",
        "AL-GHAFOOR",
        "ASH-SHAKOOR",
        "AL-‘ALEE",
        "AL-KABEER",
        "AL-HAFEEDH",
        "AL-MUQEET",
        "AL-HASEEB",
        "AL-JALEEL",
        "AL-KAREEM",
        "AR-RAQEEB",
        "AL-MUJEEB",
        "AL-WAASI’",
        "AL-HAKEEM",
        "AL-WADUD",
        "AL-MAJEED",
        "AL-BA’ITH",
        "ASH-SHAHEED",
        "AL-HAQQ",
        "AL-WAKEEL",
        "AL-QAWIYY",
        "AL-MATEEN",
        "AL-WALIYY",
        "AL-HAMEED",
        "AL-MUHSEE",
        "AL-MUBDI",
        "AL-MUEED",
        "AL-MUHYI",
        "AL-MUMEET",
        "AL-HAYY",
        "AL-QAYYOOM",
        "AL-WAAJID",
        "AL-MAAJID",
        "AL-WAAHID",
        "AL-AHAD",
        "AS-SAMAD",
        "AL-QADEER",
        "AL-MUQTADIR",
        "AL-MUQADDIM",
        "AL-MU’AKHKHIR",
        "AL-AWWAL",
        "AL-AAKHIR",
        "AZ-ZAAHIR",
        "AL-BAATIN",
        "AL-WAALI",
        "AL-MUTA’ALI",
        "AL-BARR",
        "AT-TAWWAB",
        "AL-MUNTAQIM",
        "AL-‘AFUWW",
        "AR-RA’OOF",
        "MAALIK-UL-MULK",
        "DHUL-JALAALI WAL-IKRAAM",
        "AL-MUQSIT",
        "AL-JAAMI’",
        "AL-GHANIYY",
        "AL-MUGHNI",
        "AL-MANI’",
        "AD-DHARR",
        "AN-NAFI’",
        "AN-NUR",
        "AL-HAADI",
        "AL-BADEE’",
        "AL-BAAQI",
        "AL-WAARITH",
        "AR-RASHEED",
        "AS-SABOOR"],
     ar : [
      "  الرحمن","الرحيم","الملك","القدوس","السلام","المؤمن","المهيمن","العزيز","الجبار","المتكبر","الخالق","البارئ","المصور","الغفار","القهار","الوهاب","الرزاق","الفتاح","العليم","القابض","الباسط","الخافض","الرافع"
     ],
     fr: ["Dieu",
     "Le Tout-Miséricordieux",
     "Le Très-Miséricordieux",
     "Le Souverain",
     "Le Saint",
     "La Paix",
     "La Sauvegarde",
     "Le Préservateur",
     "Le Tout Puissant",
     "Celui qui domine et contraint",
     "L'innaccessible",
     "Le Créateur",
     "Le Producteur",
     "Celui qui façonne ses créatures",
     "Qui absout beaucoup",
     "L'Irrésistible",
     "Le Très Généreux",
     "Celui qui accorde la subsistance",
     "Celui qui accorde la victoire",
     "L'Omniscient",
     "Celui qui retient et qui rétracte",
     "Celui qui étend Sa générosité",
     "Celui qui abaisse",
     "Celui qui élève",
     "Celui qui rend puissant",
     "Celui qui humilie les fiers",
     "L'Audient, Celui qui entend toute chose",
     "Le Voyant, Celui qui voit toute chose ",
     "L'Arbitre",
     "Le Juste",
     "Le Bon dans l'épreuve",
     "Le Bien-Informé",
     "Le Doux, le Très Clément",
     "L'Immense, l'Eminent",
     "Qui Pardonne",
     "Le Très-Reconnaissant",
     "L'Elevé",
     "L'Infiniment Grand",
     "Le Gardien",
     "Qui nourrit tout le monde",
     "Qui règle le compte de tout le monde",
     "Le Majestueux",
     "Le Noble",
     "L'Observateur",
     "Celui qui exauce les prières",
     "Le Vaste",
     "Le Sage",
     "Qui aime beaucoup",
     "Le Très Glorieux",
     "Qui ressuscite",
     "Le Témoin",
     "Le Vrai",
     "Le Tuteur",
     "Le Fort",
     "Le Robuste",
     "Le Protecteur",
     "Le Louable",
     "Qui connaît les comptes de tous",
     "L'Auteur",
     "Qui fait rentrer tout le monde dans le néant",
     "Qui donne la vie",
     "Qui donne la mort",
     "Le Vivant",
     "L'Immuable",
     "Qui existe",
     "L'Illustre",
     "L'Unique",
     "L' Eternel Seigneur",
     "Le Déterminant",
     "Le Tout Puissant",
     "Qui a tout précédé",
     "Qui sera après tout",
     "Le Premier, dont l'existence n'a pas de début",
     "Le Dernier, dont l'existence n'a pas de fin",
     "L'Extérieur, l'Apparent",
     "L'Intérieur, le Caché",
     "Le Monarque",
     "Le Sublime",
     "Le Bienfaiteur",
     "Qui ne cesse d'accueillir le repentir",
     "Le Vengeur",
     "L'Indulgent",
     "Le Bienveillant en grâce",
     "Le Maître du Pouvoir",
     "Détenteur de Majesté qui mérite d'être Exalté",
     "L'Equitable",
     "Le Rassembleur",
     "Le Riche par excellence",
     "Qui satisfait les besoins de Ses créatures",
     "Le Défenseur",
     "Qui peut nuire (à ceux qui L'offensent)",
     "L'Utile",
     "La Lumière",
     "Le Guide",
     "L'inventeur",
     "Le Permanent",
     "L'Héritier",
     "Qui agit avec droiture",
     "Le Patient"]
}

const backgrounds = [
    "wallpaper_1.jpeg", "wallpaper_2.jpeg", "wallpaper_3.jpeg",
    "wallpaper_4.jpeg", "wallpaper_5.jpeg", "wallpaper_6.jpeg",
    "wallpaper_7.jpeg", "wallpaper_8.jpeg", "wallpaper_9.jpeg",
    "wallpaper_10.jpeg", "wallpaper_11.jpeg", "wallpaper_12.jpeg",
    "wallpaper_13.jpeg", "wallpaper_14.jpeg", "wallpaper_15.jpeg",
    "wallpaper_16.jpeg", "wallpaper_17.jpeg", "wallpaper_18.jpeg",
    "wallpaper_19.jpeg", "wallpaper_20.jpeg", "wallpaper_21.jpeg",
    "wallpaper_22.jpeg", "wallpaper_23.jpeg", "wallpaper_24.jpeg",
    "wallpaper_25.jpeg", "wallpaper_26.jpeg"
]

const conversationsData = {
    en : [

    ],
    ar : [
        "عن عبدالله بن مسعود رضي الله عنه قال: سألت النبي صلى الله عليه وسلم: أي العمل أحب إلى الله؟ قال: (الصلاة على وقتها)، قال: ثم أي؟ قال: (ثم بر الوالدين) قال: ثم أي؟ قال: (الجهاد في سبيل الله) رواه البخاري ومسلم",
        "عن أبي هريرة رضي الله عنه قال: قال رسول الله صلى الله عليه وسلم: (كلمتان خفيفتان على اللسان، ثقيلتان في الميزان، حبيبتان إلى الرحمن، سبحان الله وبحمده، سبحان الله العظيم) رواه البخاري ومسلم",
        "عن عائشة رضي الله عنها عن النبي صلى الله عليه وسلم قال: (ركعتا الفجر خير من الدنيا وما فيها) رواه مسلم",
        "عن عمر بن الخطاب رضي الله عنه قال: سمعت رسول الله صلى الله عليه وسلم يقول: (إنما الأعمال بالنيات، وإنما لكل امرئ ما نوى، فمن كانت هجرته إلى الله ورسوله، فهجرته إلى الله ورسوله، ومن كانت هجرته لدنيا يصيبها أو امرأة يتزوجها، فهجرته إلى ما هاجر إليه) رواه البخاري ومسلم",
        "عن أبي هريرة رضي الله عنه أن رسول الله صلى الله عليه وسلم قال: (من صلى علي صلاة واحدة صلى الله عليه عشراً) رواه مسلم",
        "عَنْ أَبِي هُرَيْرَةَ أَنَّ رَسُولَ اللَّهِ صلى الله عليه وسلم قَالَ (( يَقُولُ الْعَبْدُ مَالِي مَالِي إِنَّمَا لَهُ مِنْ مَالِهِ ثَلاَثٌ مَا أَكَلَ فَأَفْنَى أَوْ لَبِسَ فَأَبْلَى أَوْ أَعْطَى فَاقْتَنَى وَمَا سِوَى ذَلِكَ فَهُوَ ذَاهِبٌ وَتَارِكُهُ لِلنَّاسِ )) صحيح مسلم",
        "عَنْ أَبِي هُرَيْرَةَ، قَالَ قَالَ رَسُولُ اللَّهِ صلى الله عليه وسلم (( وَالَّذِي نَفْسِي بِيَدِهِ لَوْ لَمْ تُذْنِبُوا لَذَهَبَ اللَّهُ بِكُمْ وَلَجَاءَ بِقَوْمٍ يُذْنِبُونَ فَيَسْتَغْفِرُونَ اللَّهَ فَيَغْفِر لَهُمْ )) صحيح مسلم",
        "عن أنس رضي الله عنه عن النبي صلى الله عليه وسلم أنه قال: (ما من مسلم يغرس غرساً أو يزرع زرعاً فيأكل منه طير أو إنسان أو بهيمة إلا كان له به صدقة) رواه البخاري ومسلم",
        "عن أبي سعيد الخدري رضي الله عنه قال: سمعت رسول الله صلى الله عليه وسلم يقول: (من رأى منكم منكرا فليغيره بيده، فإن لم يستطع فبلسانه، فإن لم يستطع فبقلبه، وذلك أضعف الإيمان) رواه مسلم",
        "عن أبي هريرة رضي الله عنه أن رسول الله صلى الله عليه وسلم قال: (أتدرون ما الغيبة؟) قالوا: الله ورسوله أعلم. قال: (ذكرك أخاك بما يكره) قيل: أرأيت إن كان في أخي ما أقول؟ قال: (إن كان فيه ما تقول فقد اغتبته، وإن لم يكن فيه ما تقول فقد بهته) رواه مسلم"
    ],
    fr : [

    ]

}

const islamicStoriesData = {
    en : [],
    ar : [
        "قصة استشهاد الفاروق عمر بن الخطاب","قصة الإمام البخاري وجمع الأحاديث", "قصة الأمانة في الإسلام","قصة التضحية بالنفس من أخلاق الإسلام",
        "قصة السيدة درة بنت أبي لهب","قصة توبة الجار السيء","قصة فتح مكة وعفو الرسول عن أهلها","قصة ماء زمزم","قصص عن الصبر على البلاء"
    ],
    fr : []
}

const islamicstoriesdetails = {
    en : [
        [

        ]
    ],
    ar : [
        [
            {
                head : "",
                para : [
                    "إن قصة استشهاد الفاروق عمر بن الخطاب رضي الله عنه من القصص المؤثرة ، حيث أنه قُتل غدرًا وعدوانًا ، ولكنه قابل الموت بكل شجاعة ، وذلك لأنه قوي الإيمان يبتغي مرضاة وجه الله ، ولما لا وهو الفاروق العادل الذي كان من اقرب الصحابة إلى رسول الله صلّ الله عليه وسلم .",
                ]
            },
            {
                head : "غلام المغيرة :",
                para : [
                    "ذات يوم أرسل المغيرة بن شعبة رضي الله عنه وهو على الكوفة إلى الفاروق عمر بن الخطاب رضي الله عنه ليستأذنه في دخول غلام يعمل صائغًا إلى المدينة ، وكانت سياسة عمر ألا يأذن لمن بقي على كفره بالدخول إلى المدينة ، غير أنه وافق على دخول ذلك الغلام الذي كتب عنه المغيرة ، حيث أخبره بأنه يقوم بأعمال تنفع الناس ",
                    ".وكان ذلك الغلام يُدعى أبا لؤلؤة المجوسي ، وذات يوم بعد دخوله المدينة قابل الفاروق قائلًا له :”إن المغيرة أثقل عليّ” ، حيث كان يشكو شدة الخراج ، فأجابه الفاروق :”اتق الله وأحسن إليه” ، وكان الفاروق يعقد النية أن يلقى المغيرة ليطلب منه التخفيف عن الغلام ، ولكن الحقد كان يأكل قلب الغلام الذي أضمر على قتل عمر بن الخطاب رضي الله عنه."
                ]
            },
            {
                head : "طعن عمر في المسجد :",
                para : [
                    'حينما حلّ فجر يوم الأربعاء والذي كان قبل انتهاء شهر ذي الحجة بأربعة أيام ، دخل أبو لؤلؤة المسجد يُخفي معه سكينًا به طرفين مسمومين ، وكان عمر رضي الله عنه يعدل صفوف المسلمين للصلاة ، وحينما قام بالتكبير باغته أبو لؤلؤة بطعنة في كتفه وأخرى في خاصرته ، حينها قال عمر :” وَكَانَ أَمْرُ اللَّهِ قَدَرًا مَّقْدُورً” ',
                    '.مضى الغلام بين المسلمين يصدر طعناته يمينًا ويسارًا في همجية وعشوائية ، حتى قام بطعن ثلاثة عشر رجلًا وقد اُستشهد منهم سبعة ، فقام أحد رجال المسلمين بإلقاء ثياب ثقيلة على الغلام الهائج ، حينها أدرك أن المسلمين قد تمكنوا منه ، فقام بطعن نفسه تحت الرداء .',
                    'أمسك عمر بن الخطاب بيد عبدالرحمن بن عوف حيث قام بتقديمه للصلاة بالمسلمين ، فصلى بن عوف صلاة خفيفة بالناس ، وتم حمل عمر بن الخطاب إلى البيت وهو ينزف حتى أُغمى عليه ، وحينما أسفر الصبح وبعد استفاقته قال :”أصلّى الناس؟” ، فأجابوه :”نعم” ، فقال :”لا إسلام لمن ترك الصلاة” ، ثم توضأ عمر وصلّى حيث استند إلى ابنه .',
                    'دعا عمر بن الخطاب ابن عباس حيث كان يحبه ، فقال له :”أخرج فناد في الناس :أعن ملأ منكم كان هذا؟” ، فأجابوه :”ما علمنا ولا اطّلعنا” ، وقيل أن القوم من شدة حزنهم قد قالوا :”لوددنا أن الله زاد في عمرك من أعمارنا ” ، وحينما علم عمر أن من طعنه هو عبد مجوسي قال :”الحمد لله الذي لم يجعل قاتلي يحاجّني عند الله بسجدة سجدها قط “.',
                    'وجاء الطبيب إلى عمر فسقاه نبيذًا فخرج من مكان جرحه ، ثم سقاه لبنًا فخرج هو الآخر من جرحه ، حينها أدرك أنه قرب الأجل ، فقال :” لو أن لي الدنيا كلها ؛ لافتديت به من هول المطّلع” ، وقام الفاروق بإرسال ابنه عبدالله إلى عائشة ، حيث قال :” انطلق إلى عائشة أم المؤمنين ؛ فقل : يقرأ عليكِ عمر السلام ولا تقل : أمير المؤمنين ، فإني لست اليوم للمؤمنين أميرًا ، وقل : يستأذن عمر أن يُدفن مع صاحبيه” ، وهو يقصد رسول الله صلّ الله عليه وسلم وأبا بكر الصديق .',
                    'وحينما أخبر ابنه السيدة عائشة ما قاله الفاروق ، أجابته بقولها :” كنت أريده لنفسي ، ولأوثرنّه به اليوم على نفسي ” ، فعاد إلى أبيه الذي سأله :” ما لديك؟ “.، فأجابه :” الذي تحب يا أمير المؤمنين ؛ أذِنتْ” ، فقال :”الحمد لله ، ما كان من شيء أهم إليّ من ذلك ، فإذا أنا قضيت فاحملوني ، ثم سلّم فقل : يستأذن عمر بن الخطاب ، فإن أذنت لي فأدخلوني ، وإن ردّتني ردّوني إلى مقابر المسلمين”.',
                    'ومات الفاروق عمر بن الخطاب رضي الله عنه ، وقام المسلمون بدفنه كما كان يرغب بجوار صاحبيه الرسول محمد عليه أفضل الصلاة والسلام وأبي بكر الصديق رضي الله عنه .'
                ]
            }
        ]
    ],
    fr : [
        [

        ]
    ]
}
const hadesData = {
    en : [],
    ar : [
       "November",
       "December"
    ],
    fr : []

}



const hadesListData = {
    en : [
            {
                head : "",
                para : [

                ]
            }
    ],
    ar : {
            head : "ادعيه رمضانية يومية",   /// music array
            para : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
    },
    fr :[
            {
                head : "",
                para : [

                ]
            }
    ]
}

const ramdanData = {
    en : [],
    ar : [
        "محتوي حصري لرمضان",
        "ادعيه رمضانية يومية",
        "فيديو رمضان",
        "صلاة تراويح"
    ],
    fr : []

}

const ramdanListData = {
    en : [
            {
                head : "",
                para : [

                ]
            }
    ],
    ar : [
            {
                head : "محتوي حصري لرمضان",
                para : [
                    "فوائد الصيام",
                    "عيد الفطر",
                    "تاريخ رمضان",
                    "ليلة القدر",
                    "الزكاة"
                ]
            },
            {
                head : "ادعيه رمضانية يومية",   /// music array
                para : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
            },
            {
                head : "",   // video urls
                para : [
                    1,2,3,4
                ]
            },
            {
                head : "صلاة تراويح",
                para : [
                    "صلاة التراويح من الشيخ سعود الشريم",
                    "صلاة التراويح من الشيخ الشريم",
                    "صلاة التراويح من الشيخ عبد الله الجهني"
                ]
            }
    ],
    fr :[
            {
                head : "",
                para : [

                ]
            }
    ]
}

const prayerAlert = {
    en : [

    ],
    ar : [
        [
            "الصبح","Al-Sobh","05:40"
        ],
        [
            "الصبح","Al-Sobh","05:40"
        ],
        [
            "الصبح","Al-Sobh","05:40"
        ],
        [
            "الصبح","Al-Sobh","05:40"
        ],
        [
            "الصبح","Al-Sobh","05:40"
        ],
        [
            "الصبح","Al-Sobh","05:40"
        ]
    ],
    fr : [

    ]
}

const commonText = {
    save : {
        en : "Save",
        fr : "Télécharger",
        ar : "تحميل"
    },
    language : {
        en : "Language",
        fr : "Langue",
        ar : "لغة"
    },
    unsubscribe : {
        en : "UNSUBSCRIBE",
        fr : "SE DÉSABONNER",
        ar : "إلغاء الاشتراك"
    },
    changeLanguage : {
        en : "Change Language",
        fr : "Changer de langue",
        ar : "تغيير اللغة"
    },
    title : {
        en : "Ibadat",
        fr : "Ibadat",
        ar : "إسلامي"
    },
    modal : {
        oops:{
            en: "Oops!",
            fr: "Oops!"
        },
        pleaseSubscribe:{
            en: "Please Subscribe to the service.",
            fr: "Veuillez vous abonner au service."
        },
        okay:{
            en: "Okay",
            fr: "D'accord"
        },
        yes:{
            en: "Yes",
            fr: "Oui"
        },
        no:{
            en: "No",
            fr: "Non"
        },
        doYouReallyUnsub : {
            en : "Do you really want to unsubscribe ?",
            fr : "Voulez-vous vraiment vous désinscrire ?"
        }
    }


}

const LoginPageData = {
    heading: {
        en: "Connecting Afganistan",
        dr: "اتصال افغانستان",
        ps: "افغانستان سره نښلوي"
    }

}




const hadithData = {
    "month":[
        {
            "id": 1,
            "month": "april"
        },
        {
            "id": 2,
            "month": "may"
        },
        {
            "id": 3,
            "month": "june"
        }
    ],
    "content1": [
        {
            "id": 1,
            "name": "bukhair_1490.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhair_1490.mp3"
        },
        {
            "id": 2,
            "name": "bukhari_1071.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1071.mp3"
        },
        {
            "id": 3,
            "name": "bukhari_1072.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1072.mp3"
        },
        {
            "id": 4,
            "name": "bukhari_1073.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1073.mp3"
        },
        {
            "id": 5,
            "name": "bukhari_1294.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1294.mp3"
        },
        {
            "id": 6,
            "name": "bukhari_1333.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1333.mp3"
        },
        {
            "id": 7,
            "name": "bukhari_1365.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1365.mp3"
        },
        {
            "id": 8,
            "name": "bukhari_1388.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1388.mp3"
        },
        {
            "id": 9,
            "name": "bukhari_1280.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1280.mp3"
        },
        {
            "id": 10,
            "name": "bukhari_1393.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1393.mp3"
        },
        {
            "id": 11,
            "name": "bukhari_1506.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1506.mp3"
        },
        {
            "id": 12,
            "name": "bukhari_1593.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1593.mp3"
        },
        {
            "id": 13,
            "name": "bukhari_1773.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1773.mp3"
        },
        {
            "id": 14,
            "name": "bukhari_1292.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1292.mp3"
        },
        {
            "id": 15,
            "name": "bukhari_1490.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1490.mp3"
        }
    ],
    "content2": [
        {
            "id": 1,
            "name": "bukhari_1804.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1804.mp3"
        },
        {
            "id": 2,
            "name": "bukhari_1885.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1885.mp3"
        },
        {
            "id": 3,
            "name": "bukhari_1925.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1925.mp3"
        },
        {
            "id": 4,
            "name": "bukhari_1927.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1927.mp3"
        },
        {
            "id": 5,
            "name": "bukhari_1938.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1938.mp3"
        },
        {
            "id": 6,
            "name": "bukhari_1939.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1939.mp3"
        },
        {
            "id": 7,
            "name": "bukhari_1954.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1954.mp3"
        },
        {
            "id": 8,
            "name": "bukhari_1985.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_1985.mp3"
        },
        {
            "id": 9,
            "name": "bukhari_2005.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_2005.mp3"
        },
        {
            "id": 10,
            "name": "bukhari_2014.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_2014.mp3"
        },
        {
            "id": 11,
            "name": "bukhari_2017.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_2017.mp3"
        },
        {
            "id": 12,
            "name": "bukhari_2022.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_2022.mp3"
        },
        {
            "id": 13,
            "name": "bukhari_2024.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_2024.mp3"
        },
        {
            "id": 14,
            "name": "bukhari_6103.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6103.mp3"
        },
        {
            "id": 15,
            "name": "bukhari_6181.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6181.mp3"
        }
    ],
    "content3":[
        {
            "id": 1,
            "name": "bukhari_6234.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6234.mp3"
        },
        {
            "id": 2,
            "name": "bukhari_6253.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6253.mp3"
        },
        {
            "id": 3,
            "name": "bukhari_6290.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6290.mp3"
        },
        {
            "id": 4,
            "name": "bukhari_6307.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6307.mp3"
        },
        {
            "id": 5,
            "name": "bukhari_6407.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6407.mp3"
        },
        {
            "id": 6,
            "name": "bukhari_6412.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6412.mp3"
        },
        {
            "id": 7,
            "name": "bukhari_6419.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6419.mp3"
        },
        {
            "id": 8,
            "name": "bukhari_6456.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6456.mp3"
        },
        {
            "id": 9,
            "name": "bukhari_6462.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6462.mp3"
        },
        {
            "id": 10,
            "name": "bukhari_6487.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6487.mp3"
        },
        {
            "id": 11,
            "name": "bukhari_6555.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6555.mp3"
        },
        {
            "id": 12,
            "name": "bukhari_6597.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6597.mp3"
        },
        {
            "id": 13,
            "name": "bukhari_6681.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6681.mp3"
        },
        {
            "id": 14,
            "name": "bukhari_6862.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6862.mp3"
        },
        {
            "id": 15,
            "name": "bukhari_6863.mp3",
            "fileSource": "https://multimedia.ibadatapp.com/hadith/audios/bukhari_6863.mp3"
        }
    ]
}








export {
    homepageData,
    quranData,
    quranDetails,
    duaData,
    duaDetails,
    allahNames,
    backgrounds,
    conversationsData,
    islamicStoriesData,
    islamicstoriesdetails,
    ramdanData,
    ramdanListData,
    prayerAlert,
    hadesData,
    hadesListData,
    commonText,
    duaAudios,
    hadithData
};